import classNames from 'classnames';
import styles from './ArticleHeader.module.scss';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { UI_Picture } from 'ui/components/1-atoms/Media/Picture/Picture';

export interface ArticleHeaderProps {
	className?: string;
	kicker?: string;
	teaser?: string;
	heading?: React.ReactNode;
	image?: {
		url: string;
		focalPoint?: { left: number; top: number };
		extension?: string;
	};
	altText?: string;
	imageCropping?: 'cover' | 'contain';
}

export const UI_ArticleHeader = ({ className, teaser, heading, kicker, image, altText, imageCropping }: ArticleHeaderProps) => (
	<header className={classNames(styles.ArticleHeader, className)}>
		<div className={classNames(styles.ArticleHeader_wrapper, className)}>
			<div className={styles.ArticleHeader_kicker}>{kicker}</div>

			<UI_Heading headingLevel="h1" style="lg" className={styles.ArticleHeader_heading}>
				{heading}
			</UI_Heading>

			<div className={styles.ArticleHeader_teaser}>{teaser}</div>
		</div>
		{image && (
			<UI_Picture
				imageRatio={0.5625}
				url={image?.url}
				altText={altText}
				focalPoint={image?.focalPoint}
				sizes="(min-width:768px) 50vw, 100vw"
				imageCropping={imageCropping}
			/>
		)}
	</header>
);
